/* 商品ページの操作まわり。
   - 画像ギャラリーはスクロールスナップでスワイプできる（矢印が押しづらいという指摘への対応）
   - カラー/サイズの選択に合わせて、在庫のない組み合わせを無効化し価格を切り替える
   - 数量の −/＋
*/
(() => {
  const root = document.querySelector('.sk-pdp');
  if (!root) return;

  /* ---------- 画像ギャラリー ---------- */
  const track = root.querySelector('[data-sk-gtrack]');
  const thumbs = [...root.querySelectorAll('[data-sk-thumb]')];
  const count = root.querySelector('[data-sk-gcount]');

  if (track) {
    const slides = [...track.children];
    const goTo = (i) => {
      const idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const currentIndex = () => {
      const c = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let dist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - track.offsetLeft + s.offsetWidth / 2 - c);
        if (d < dist) {
          dist = d;
          best = i;
        }
      });
      return best;
    };

    root.querySelector('[data-sk-gprev]')?.addEventListener('click', () => goTo(currentIndex() - 1));
    root.querySelector('[data-sk-gnext]')?.addEventListener('click', () => goTo(currentIndex() + 1));
    thumbs.forEach((b) => b.addEventListener('click', () => goTo(Number(b.dataset.index))));

    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = currentIndex();
        thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
        if (count) count.textContent = String(i + 1);
        // 選んだサムネが見える位置まで寄せる
        thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      });
    });
  }

  /* ---------- 数量 ---------- */
  const qty = root.querySelector('[data-sk-qty] input');
  root.querySelector('[data-sk-qty-minus]')?.addEventListener('click', () => {
    qty.value = Math.max(1, Number(qty.value || 1) - 1);
  });
  root.querySelector('[data-sk-qty-plus]')?.addEventListener('click', () => {
    qty.value = Number(qty.value || 1) + 1;
  });

  /* ---------- バリエーション ---------- */
  const data = root.querySelector('[data-sk-variants]');
  if (!data) return;
  const variants = JSON.parse(data.textContent);
  const inputs = [...root.querySelectorAll('[data-sk-option]')];
  const idInput = root.querySelector('[data-sk-variant-id]');
  const btn = root.querySelector('[data-sk-add]');
  const priceEls = [...root.querySelectorAll('[data-sk-price]')];
  if (!inputs.length) return;

  const optionCount = new Set(inputs.map((i) => i.dataset.index)).size;
  /* 金額整形はストアの money_format に従う（'¥' と 'ja-JP' の直書きをやめた・2026-08-10） */
  const T = (window.Sekka && window.Sekka.t) || {};
  const money = (cents) =>
    window.Sekka && window.Sekka.money ? window.Sekka.money(cents) : String(Math.round(cents / 100));

  const chosen = () => {
    const out = [];
    for (let i = 0; i < optionCount; i++) {
      const c = inputs.find((x) => x.dataset.index === String(i) && x.checked);
      out.push(c ? c.value : null);
    }
    return out;
  };

  // 他の選択と組み合わせて在庫がある値かどうかで、選べない選択肢を灰色にする
  const markAvailability = () => {
    const sel = chosen();
    inputs.forEach((input) => {
      const i = Number(input.dataset.index);
      const test = sel.slice();
      test[i] = input.value;
      const ok = variants.some(
        (v) => v.available && test.every((c, n) => c === null || v.options[n] === c)
      );
      input.nextElementSibling?.classList.toggle('is-unavailable', !ok);
    });
  };

  const sync = () => {
    const sel = chosen();
    inputs.forEach((input) => {
      if (!input.checked) return;
      const label = root.querySelector(`[data-sk-current="${input.dataset.index}"]`);
      if (label) label.textContent = input.value;
    });

    const v = variants.find((x) => sel.every((c, i) => x.options[i] === c));
    markAvailability();
    if (!v) return;

    idInput.value = v.id;
    btn.disabled = !v.available;
    btn.textContent = v.available ? T.add_to_cart || 'Add to cart' : T.sold_out || 'Sold out';

    // 売り切れ時の再入荷導線
    var restock = document.querySelector('[data-sk-restock]');
    // 発売前タグの商品（data-always）は在庫に関係なく出したまま
    if (restock) restock.hidden = v.available && !restock.hasAttribute('data-always');

    // 追従バーのボタンも本物と同じ状態にする。
    // ただし選択シートがある商品（2026-10-10〜）は、追従ボタンは「選ぶ」入口なので
    // 本体の選択が売り切れでも押せるまま（全バリエーション売り切れのときだけLiquidが無効で出す）
    const satcBtn = document.querySelector('[data-sk-satc-add]');
    if (satcBtn && !document.querySelector('[data-sk-vsheet]')) {
      satcBtn.disabled = !v.available;
      satcBtn.textContent = v.available ? T.add_to_cart || 'Add to cart' : T.sold_out || 'Sold out';
    }

    // バリアント画像グルーピング（2026-08-08・アパレル対応）。
    // 画像のalt末尾等に「color:シルバー」の形で書いておくと、
    // その色を選んだときに該当画像だけ表示する。
    // 1枚もタグが無ければ何もしない＝既存店（mimi）は従来どおり全表示。
    (function () {
      var slides = document.querySelectorAll('[data-media-alt]');
      if (!slides.length) return;
      var tagged = false;
      slides.forEach(function (el) {
        if (/color\s*:/i.test(el.dataset.mediaAlt || '')) tagged = true;
      });
      if (!tagged) return;
      var vals = v.options.map(function (o) { return String(o).toLowerCase(); });
      slides.forEach(function (el) {
        var m = /color\s*:\s*([^|]+)/i.exec(el.dataset.mediaAlt || '');
        var show = true;
        if (m) show = vals.indexOf(m[1].trim().toLowerCase()) !== -1;
        el.style.display = show ? '' : 'none';
      });
    })();

    // 残り点数。しきい値と文言はテーマ設定（在庫バッジと共通）。
    // variants JSONに在庫数が入らないため、Liquidが吐いた data-qty マップを引く
    const scar = document.querySelector('[data-sk-scarcity]');
    if (scar) {
      const thr = Number(scar.dataset.threshold || 0);
      const map = {};
      (scar.dataset.qty || '').split(',').forEach((pair) => {
        const [id, q] = pair.split(':');
        if (id) map[id.trim()] = Number(q);
      });
      const q = map[String(v.id)];
      const on = v.available && typeof q === 'number' && q > 0 && q <= thr;
      scar.hidden = !on;
      if (on) scar.textContent = (scar.dataset.template || T.scarcity || '{count} left').replace('{count}', q);
    }
    const html = v.available
      ? `${money(v.price)}<span class="sk-pdp__tax">${T.tax_included || ''}</span>`
      : `<span class="sk-pdp__price-out">${money(v.price)}</span><span class="sk-card__soldout">SOLD OUT</span>`;
    priceEls.forEach((el) => (el.innerHTML = html));
  };

  inputs.forEach((i) => i.addEventListener('change', sync));
  sync();
})();

/* ------------------------------------------------------------
   リングサイズの測り方シート（クライアント要望6・2026-08-07）
   下から迫り上げて、閉じたら元のスクロール位置に戻す。
   ------------------------------------------------------------ */
(function () {
  var sheet = document.querySelector('[data-sk-sg]');
  if (!sheet) return;

  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    sheet.hidden = false;
    // hidden を外した直後だと transition が走らないので次フレームで付ける
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
    var close = sheet.querySelector('.sk-sg__close');
    if (close) close.focus();
  }

  function close() {
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
    window.setTimeout(function () {
      sheet.hidden = true;
    }, 320);
  }

  document.addEventListener('click', function (ev) {
    if (ev.target.closest('[data-sk-sg-open]')) {
      ev.preventDefault();
      open();
      return;
    }
    if (ev.target.closest('[data-sk-sg-close]')) {
      close();
      return;
    }

    var tab = ev.target.closest('[data-sk-sg-tab]');
    if (!tab) return;
    var n = tab.dataset.skSgTab;
    sheet.querySelectorAll('[data-sk-sg-tab]').forEach(function (t) {
      var on = t.dataset.skSgTab === n;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    sheet.querySelectorAll('[data-sk-sg-panel]').forEach(function (p) {
      var on = p.dataset.skSgPanel === n;
      p.classList.toggle('is-on', on);
      p.hidden = !on;
    });
    sheet.querySelector('.sk-sg__body').scrollTop = 0;
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && !sheet.hidden) close();
  });
})();


/* ------------------------------------------------------------
   追従カートバー（2026-08-08）
   本物の「カートに入れる」が画面の上へ消えたときだけ画面下に出す。
   分身ボタンは本物のフォームを送信するだけなので、
   選択中のバリエーション・数量がそのまま効く。
   ------------------------------------------------------------ */
(function () {
  var bar = document.querySelector('[data-sk-satc]');
  var real = document.querySelector('[data-sk-add]');
  if (!bar || !real || !('IntersectionObserver' in window)) return;

  // rootMarginで観測範囲を下へ無限に伸ばす。こうすると「非交差」に
  // なるのはボタンが画面の上へ消えたときだけになる。
  // 素の観測だと、アンカーリンクや戻るボタンのスクロール復元のように
  // 画面の下から上へ一足飛びに通過した場合、交差状態が
  // 「非交差→非交差」で変化なし扱いになりコールバックが来ない（実測で踏んだ）。
  var io = new IntersectionObserver(function (entries) {
    var e = entries[entries.length - 1];
    var show = !e.isIntersecting;
    bar.hidden = !show;
    // LINEフロートをバーの上に逃がすためのフック（sekka.css側）
    document.body.classList.toggle('sk-satc-on', show);
  }, { rootMargin: '0px 0px 999999px 0px' });
  io.observe(real);

  bar.querySelector('[data-sk-satc-add]').addEventListener('click', function () {
    // バリエーションのある商品は、選ぶシートを開く（下の「選択シート」）
    if (document.querySelector('[data-sk-vsheet]')) {
      document.dispatchEvent(new CustomEvent('sekka:vsheet-open'));
      return;
    }
    if (real.disabled) return;
    var form = real.closest('form');
    if (form && form.requestSubmit) form.requestSubmit(real);
    else real.click();
  });
})();


/* ------------------------------------------------------------
   追従ボタンの「カラー・サイズを選ぶ」シート（クライアント要望・2026-10-08）
   - 本体で選び直していればその選択を引き継ぐ。触っていなければ未選択から始める
     （先頭のカラー・サイズのまま入ってしまうのが要望の発端）。選択肢が1つの項目は最初から選択
   - どの組み合わせでも在庫が無い値は選べない（disabled）。他の選択との組み合わせで
     売り切れになる値は薄く見せ、押したらぶつかる側の選択を外して選び直してもらう
   - 「カートに入れる」で本体の選択と数量に書き戻し、本体のフォームを送る
     （カートドロワー・計測は本体と同じ1本の経路を通る）
   ------------------------------------------------------------ */
(function () {
  var sheet = document.querySelector('[data-sk-vsheet]');
  var root = document.querySelector('.sk-pdp');
  var data = root && root.querySelector('[data-sk-variants]');
  var real = document.querySelector('[data-sk-add]');
  if (!sheet || !data || !real) return;

  var variants = JSON.parse(data.textContent);
  var T = (window.Sekka && window.Sekka.t) || {};
  var money = function (c) {
    return window.Sekka && window.Sekka.money ? window.Sekka.money(c) : String(Math.round(c / 100));
  };
  var inputs = Array.prototype.slice.call(sheet.querySelectorAll('[data-sk-sheet-option]'));
  var mainInputs = Array.prototype.slice.call(root.querySelectorAll('[data-sk-option]'));
  var addBtn = sheet.querySelector('[data-sk-vsheet-add]');
  var priceEl = sheet.querySelector('[data-sk-vsheet-price]');
  var thumb = sheet.querySelector('[data-sk-vsheet-thumb]');
  var qtyEl = sheet.querySelector('[data-sk-vsheet-qty]');
  var optionNames = Array.prototype.slice.call(sheet.querySelectorAll('.sk-picker__label')).map(function (el) {
    return ((el.firstChild && el.firstChild.textContent) || '').trim();
  });
  var count = optionNames.length;
  var touched = false; // 本体の選択肢をお客様が一度でも触ったか
  var lastFocus = null;

  mainInputs.forEach(function (i) {
    i.addEventListener('change', function (e) {
      if (e.isTrusted) touched = true;
    });
  });

  function byIndex(i) {
    return inputs.filter(function (x) { return x.dataset.index === String(i); });
  }
  function empty() {
    var a = [];
    for (var i = 0; i < count; i++) a.push(null);
    return a;
  }
  function chosen() {
    var out = [];
    for (var i = 0; i < count; i++) {
      var c = byIndex(i).filter(function (x) { return x.checked; })[0];
      out.push(c ? c.value : null);
    }
    return out;
  }
  function anyAvailable(test) {
    return variants.some(function (v) {
      return v.available && test.every(function (c, n) { return c === null || v.options[n] === c; });
    });
  }
  function current() {
    var sel = chosen();
    if (sel.indexOf(null) !== -1) return null;
    return variants.filter(function (v) {
      return sel.every(function (c, i) { return v.options[i] === c; });
    })[0] || null;
  }

  function render() {
    var sel = chosen();
    inputs.forEach(function (input) {
      var i = Number(input.dataset.index);
      // どの組み合わせでも在庫が無い値は選べない
      var solo = empty();
      solo[i] = input.value;
      input.disabled = !anyAvailable(solo);
      var test = sel.slice();
      test[i] = input.value;
      var label = input.nextElementSibling;
      if (label) {
        label.classList.toggle('is-unavailable', !anyAvailable(test));
        label.classList.toggle('is-disabled', input.disabled);
      }
    });
    sel.forEach(function (val, i) {
      var cur = sheet.querySelector('[data-sk-sheet-current="' + i + '"]');
      if (cur) cur.textContent = val || '';
    });

    var v = current();
    if (!v) {
      var missing = optionNames.filter(function (_, i) { return sel[i] === null; });
      addBtn.disabled = true;
      addBtn.textContent = (addBtn.dataset.prompt || '[options]').replace('[options]', missing.join('・'));
      return;
    }
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? T.add_to_cart || 'Add to cart' : T.sold_out || 'Sold out';
    if (priceEl) {
      priceEl.innerHTML =
        money(v.price) + (v.available ? '<span class="sk-pdp__tax">' + (T.tax_included || '') + '</span>' : '');
    }
    if (thumb && v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src;
      thumb.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    }
  }

  function setFrom(values) {
    inputs.forEach(function (x) {
      x.checked = values[Number(x.dataset.index)] === x.value;
    });
  }

  function open() {
    var start = [];
    for (var i = 0; i < count; i++) {
      var all = byIndex(i);
      var ok = all.filter(function (x) {
        var solo = empty();
        solo[i] = x.value;
        return anyAvailable(solo);
      });
      var m = mainInputs.filter(function (x) { return x.dataset.index === String(i) && x.checked; })[0];
      if (touched && m) start.push(m.value);
      else if (all.length === 1 || ok.length === 1) start.push((ok[0] || all[0]).value);
      else start.push(null);
    }
    setFrom(start);
    // 引き継いだ組み合わせが売り切れなら、選び直してもらう
    var v = current();
    if (v && !v.available) {
      setFrom(start.map(function (val, i) { return byIndex(i).length === 1 ? val : null; }));
    }
    var mq = root.querySelector('[data-sk-qty] input');
    qtyEl.value = mq ? Math.max(1, Number(mq.value || 1)) : 1;
    render();

    lastFocus = document.activeElement;
    sheet.hidden = false;
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    var closeBtn = sheet.querySelector('.sk-sg__close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    sheet.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    window.setTimeout(function () { sheet.hidden = true; }, 320);
  }

  document.addEventListener('sekka:vsheet-open', open);

  sheet.addEventListener('change', function (e) {
    var input = e.target.closest('[data-sk-sheet-option]');
    if (!input) return;
    // 他の選択と組み合わせると売り切れになる値を選んだら、ぶつかる側の選択を外す
    var sel = chosen();
    if (!anyAvailable(sel)) {
      var keep = Number(input.dataset.index);
      setFrom(sel.map(function (val, i) {
        if (i === keep || byIndex(i).length === 1) return val;
        var test = empty();
        test[keep] = sel[keep];
        test[i] = val;
        return anyAvailable(test) ? val : null;
      }));
    }
    render();
  });

  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-sk-vsheet-close]')) { close(); return; }
    if (e.target.closest('[data-sk-vsheet-minus]')) { qtyEl.value = Math.max(1, Number(qtyEl.value || 1) - 1); return; }
    if (e.target.closest('[data-sk-vsheet-plus]')) { qtyEl.value = Number(qtyEl.value || 1) + 1; return; }
    if (!e.target.closest('[data-sk-vsheet-add]')) return;
    var v = current();
    if (!v || !v.available) return;
    // 本体の選択・数量に書き戻す（本体の sync が価格・在庫表示・variant id を合わせる）
    var sel = chosen();
    mainInputs.forEach(function (x) {
      if (sel[Number(x.dataset.index)] === x.value && !x.checked) {
        x.checked = true;
        x.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    var idInput = root.querySelector('[data-sk-variant-id]');
    if (idInput) idInput.value = v.id;
    var mq = root.querySelector('[data-sk-qty] input');
    if (mq) mq.value = Math.max(1, Number(qtyEl.value || 1));
    close();
    var form = real.closest('form');
    real.disabled = false;
    if (form && form.requestSubmit) form.requestSubmit(real);
    else real.click();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) close();
  });
})();


/* ------------------------------------------------------------
   刻印のライブプレビュー（2026-08-08）
   入力した文字を明朝でその場に映す。書体の雰囲気を見せるだけの軽い演出。
   ------------------------------------------------------------ */
(function () {
  var input = document.querySelector('[data-sk-engrave]');
  var prev = document.querySelector('[data-sk-engrave-preview]');
  if (!input || !prev) return;
  input.addEventListener('input', function () {
    var t = input.value.trim();
    prev.hidden = !t;
    prev.textContent = t;
  });
})();

/* ------------------------------------------------------------
   アパレルサイズ表のcm/inch切替（2026-08-08）
   数字のセルだけ 2.54 で割って1桁で出す。単位付き文字列は触らない。
   ------------------------------------------------------------ */
(function () {
  var box = document.querySelector('[data-sk-sizet-units]');
  var table = document.querySelector('[data-sk-sizet]');
  if (!box || !table) return;
  box.addEventListener('click', function (ev) {
    var btn = ev.target.closest('button[data-unit]');
    if (!btn) return;
    var unit = btn.dataset.unit;
    box.querySelectorAll('button').forEach(function (b) {
      b.classList.toggle('is-on', b === btn);
    });
    table.querySelectorAll('td[data-cm]').forEach(function (td) {
      var cm = td.dataset.cm;
      if (!/^[\d.]+$/.test(cm)) { td.textContent = cm; return; }
      td.textContent = unit === 'in' ? (Number(cm) / 2.54).toFixed(1) : cm;
    });
  });
})();
